module.exports = __webpack_public_path__ + "img/mock-report-bg.c8e0c732.png";